import { render, staticRenderFns } from "./ManagePackages.vue?vue&type=template&id=1a2d0fa9&scoped=true"
import script from "./ManagePackages.vue?vue&type=script&lang=js"
export * from "./ManagePackages.vue?vue&type=script&lang=js"
import style0 from "./ManagePackages.vue?vue&type=style&index=0&id=1a2d0fa9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d0fa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2d0fa9')) {
      api.createRecord('1a2d0fa9', component.options)
    } else {
      api.reload('1a2d0fa9', component.options)
    }
    module.hot.accept("./ManagePackages.vue?vue&type=template&id=1a2d0fa9&scoped=true", function () {
      api.rerender('1a2d0fa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/managePackages/ManagePackages.vue"
export default component.exports